import { render, staticRenderFns } from "./moneyDetial.vue?vue&type=template&id=252aa632&scoped=true&"
import script from "./moneyDetial.vue?vue&type=script&lang=js&"
export * from "./moneyDetial.vue?vue&type=script&lang=js&"
import style0 from "./moneyDetial.vue?vue&type=style&index=0&id=252aa632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252aa632",
  null
  
)

component.options.__file = "moneyDetial.vue"
export default component.exports